import { gql } from "@apollo/client";

export const UPDATE_TEMPLATE_STAMP = gql`
  mutation updateTemplateStamp(
    $templateId: String
    $clientIdentifier: String
    $input: TemplateStampInput
  ) {
    invoiceInterpretation {
      updateTemplateStamp(
        templateId: $templateId
        clientIdentifier: $clientIdentifier
        input: $input
      ) {
        success
      }
    }
  }
`;
